import { ww } from 'bits/global'

function connectRealtime (options): void {
  const realtime = new ww.$state.Lib.Realtime(options)
  realtime.connect()
  // For realtime presence detection. Can remove once that is ported.
  ww.realtime = realtime
}

export {
  connectRealtime,
}
